<template>
  <div
    class="moreRecord"
  >
    <div class="result-module">
      <section>
        <header>
          <titleBar title="全部战绩" />
        </header>
        <div class="list">
          <teamRecordList :teamRecordData="teamRecordData" :isSpring="isSpring" :source="'moreRecord'" />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { teamRecord } from "../../api/winterGame";
import teamRecordList from "./components/teamRecordList.vue";
import titleBar from "./components/titleBar.vue";
export default {
  components: {
    teamRecordList,
    titleBar,
  },
  data() {
    return {
      teamInfo: {
        teamName: "",
        servicePointName: "",
      },
      campusId: "",
      agentUserId: "",
      padTeamId: "",
      seasonId: "",
      teamRecordData: [],
      isSpring: false,
    };
  },
  mounted() {
    this.campusId = this.$route.query.campusId;
    this.agentUserId = this.$route.query.agentUserId;
    this.padTeamId = this.$route.query.padTeamId;
    this.seasonId = this.$route.query.seasonId;
    this.initTeamInfo();
    this.teamRecord();
  },

  methods: {
    initTeamInfo() {
      let teamInfo = localStorage.getItem("teamInfo");
      this.teamInfo = JSON.parse(teamInfo);
    },
    async teamRecord() {
      let params = {
        param: {
          currentCampusId: this.campusId,
          currentUserId: this.agentUserId,
          padTeamId: this.padTeamId,
          scheduleId: "",
          seasonId: "",
        },
      };
      let res = await teamRecord(params);
      if (res.code == 0) {
        // 统一为数组
        let arr = Array.isArray(res.data)
          ? res.data
          : res.data
          ? [res.data]
          : [];
        this.teamRecordData = arr;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.moreRecord {
  width: 100%;
  height: 100%;
  padding-top: 32px;
  .result-module {
    header {
      margin-bottom: 16px;
    }
  }
}
</style>
